import { z } from 'zod';

export const numberItemFromQuery = z.preprocess((v: unknown) => {
    if (typeof v === 'string' || typeof v === 'number') return Number(v);
    return v;
}, z.number().finite());
